const setLead = (userObj) => {
    return {
        type: "SET_LEAD",
        payload: userObj
    }
}

const setCustomer = (userObj) => {
    return {
        type: "SET_CUSTOMER",
        payload: userObj
    }
}


const allFunCall = {
    setLead,
    setCustomer
  };

export default allFunCall